import React, { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  getAdminSetting,
  updateAdminSetting,
} from "../../../redux/slices/adminSetting";

const AdminSetting = () => {
  const dispatch = useDispatch();
  const { admin } = useSelector((state) => state.userSlice);
  const { adminSetting } = useSelector((state) => state.adminSettingSlice);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    primaryEmail: "",
    secondaryEmail: "",
    tertiaryEmail: "",
    serviceTax: 0,
    serviceTaxType: "p",
    firstOrderDiscount: "",
    firstOrderDiscountType: "p",
    rescheduleBeforeTime: "",
    cancelBeforeTime: "",
  });

  useEffect(() => {
    setFormData({
      primaryEmail: admin?.email,
      secondaryEmail: admin.otherEmails?.secondaryEmail,
      tertiaryEmail: admin.otherEmails?.tertiaryEmail,
      serviceTax: adminSetting.serviseTax?.[0].serviceTax,
      serviceTaxType: adminSetting.serviseTax?.[0].serviceTaxType || "f",
      firstOrderDiscount: adminSetting.serviseTax?.[0].firstOrderDiscount || "",
      firstOrderDiscountType:
        adminSetting.serviseTax?.[0].firstOrderDiscountType || "f",
      rescheduleBeforeTime: adminSetting.weatherTime?.rescheduleBeforeTime,
      cancelBeforeTime: adminSetting.weatherTime?.cancelBeforeTime,
    });
  }, [admin, adminSetting]);

  useEffect(() => {
    dispatch(getAdminSetting(setLoading));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    dispatch(updateAdminSetting(formData, setLoading));
  };

  const renderHourOptions = () => {
    return Array.from({ length: 24 }, (_, i) => i + 1).map((hour) => (
      <option key={hour} value={hour}>
        {hour}
      </option>
    ));
  };

  return (
    <div>
      <Row className="d-flex justify-content-center">
        <Col md={5}>
          <div className="card shadow-sm" style={{ borderRadius: 10 }}>
            <div className="card-body">
              <h6 className="card-title d-flex align-items-center mb-4">
                <MdOutlineAdminPanelSettings size={22} />
                &nbsp;<b>Admin Settings</b>
              </h6>

              <Row>
                <Col md={12}>
                  {/* Primary Email */}
                  <div className="mb-3 input_dark flex-column">
                    <label className="form-label">Primary Email</label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      value={formData.primaryEmail}
                    />
                  </div>

                  {/* Secondary Email */}
                  <div className="mb-3 input_dark flex-column">
                    <label className="form-label">Secondary Email</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Secondary Email"
                      value={formData.secondaryEmail}
                      onChange={(e) =>
                        setFormData({ ...formData, secondaryEmail: e.target.value })
                      }
                    />
                  </div>

                  {/* Tertiary Email */}
                  <div className="mb-3 input_dark flex-column">
                    <label className="form-label">Tertiary Email</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Tertiary Email"
                      value={formData.tertiaryEmail}
                      onChange={(e) =>
                        setFormData({ ...formData, tertiaryEmail: e.target.value })
                      }
                    />
                  </div>

                  {/* Service Tax + Type */}
                  <Row>
                    <Col md={6}>
                      <div className="mb-3 input_dark flex-column">
                        <label className="form-label">Service Tax</label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Service Tax"
                          value={formData.serviceTax}
                          onChange={(e) =>
                            setFormData({ ...formData, serviceTax: e.target.value })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3 input_dark flex-column">
                        <label className="form-label">Service Tax Type</label>
                        <select
                          className="form-control"
                          style={{ textAlign: "left", textIndent: "4px" }}   // ⭐ FIX APPLIED
                          value={formData.serviceTaxType}
                          onChange={(e) =>
                            setFormData({ ...formData, serviceTaxType: e.target.value })
                          }
                        >
                          <option value="f">Flat</option>
                          <option value="p">Percentage</option>
                        </select>
                      </div>
                    </Col>
                  </Row>

                  {/* First Order Discount + Type */}
                  {/* <Row>
                    <Col md={6}>
                      <div className="mb-3 input_dark flex-column">
                        <label className="form-label">First Order Discount</label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Discount"
                          value={formData.firstOrderDiscount}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              firstOrderDiscount: e.target.value,
                            })
                          }
                        />
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="mb-3 input_dark flex-column">
                        <label className="form-label">Discount Type</label>
                        <select
                          className="form-control"
                          style={{ textAlign: "left", textIndent: "4px" }}   // ⭐ FIX APPLIED
                          value={formData.firstOrderDiscountType}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              firstOrderDiscountType: e.target.value,
                            })
                          }
                        >
                          <option value="f">Flat</option>
                          <option value="p">Percentage</option>
                        </select>
                      </div>
                    </Col>
                  </Row> */}

                  {/* Reschedule */}
                  <div className="mb-3 input_dark flex-column">
                    <label className="form-label">Reschedule Time (Hours)</label>
                    <select
                      className="form-control"
                      value={formData.rescheduleBeforeTime}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          rescheduleBeforeTime: e.target.value,
                        })
                      }
                    >
                      {renderHourOptions()}
                    </select>
                  </div>

                  {/* Cancel */}
                  <div className="mb-3 input_dark flex-column">
                    <label className="form-label">Cancel Time (Hours)</label>
                    <select
                      className="form-control"
                      value={formData.cancelBeforeTime}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cancelBeforeTime: e.target.value,
                        })
                      }
                    >
                      {renderHourOptions()}
                    </select>
                  </div>
                </Col>

                {/* Submit */}
                <Col md={6} className="d-flex justify-content-center">
                  <button
                    disabled={loading}
                    className="btn_primary_outline_sm py-2 mt-3 w-100"
                    onClick={handleSubmit}
                  >
                    {loading ? <Spinner /> : "Update Settings"}
                  </button>
                </Col>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AdminSetting;
